import { z } from "zod"

export const planFeatureSchema = z.object({
  key: z.string().min(1, "Key is required"),
  value: z.string().min(1, "Value is required"),
})

export const corePlanSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Plan name is required"),
  description: z.string().min(1, "Description is required"),
  priceType: z.enum(["FIXED", "RANGE"]).default("FIXED"),
  minPrice: z.coerce.number().min(0, "Price must be a positive number"),
  maxPrice: z.coerce.number().optional().nullable(),
  currency: z.string().default("USD"),
  features: z.array(planFeatureSchema).default([]),
  recommended: z.boolean().default(false), // ← NEW
  order: z.number().optional(),
})

export const coreServiceSchema = z.object({
  title: z.string().min(1, "Title is required"),
  slug: z.string().min(1, "Slug is required").regex(/^[a-z0-9-]+$/, "Slug must be lowercase letters, numbers and hyphens"),
  description: z.string().min(1, "Description is required"),
  image: z.string().min(1, "Image is required"),
  featured: z.boolean().default(false),
  // A service may ship with 0 plans (redesign: no-plan / single default-plan services).
  plans: z.array(corePlanSchema).default([]),
})

export type CoreServiceSchema = z.infer<typeof coreServiceSchema>
export type CorePlanSchema = z.infer<typeof corePlanSchema>
export type PlanFeatureSchema = z.infer<typeof planFeatureSchema>

// Redesign: the modal collects only name + email (the contact-method step is removed).
export const planSelectionSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Valid email is required"),
})

export type PlanSelectionSchema = z.infer<typeof planSelectionSchema>